var text_field_default = {
  "root": "SDraP",
  "text": "KwVrX",
  "input": "cR2zK",
  "small": "c1XkK",
  "medium": "P-01N",
  "large": "BHl11",
  "webview": "nPQr5",
  "endAdornment": "QAIms",
  "shown": "rSt-U",
  "value": "MN2Ey",
  "spinner": "OGBOg",
  "spin": "wN4-K"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
